const PASSWORD_NONE = 0;
const PASSWORD_WEAK = 1;
const PASSWORD_FAIR = 2;
const PASSWORD_GOOD = 3;
const PASSWORD_STRONG = 4;

function determinePasswordStrength(value) {
  const isNumeric = /[0-9]/;
  const hasLower = /[a-z ]/;
  const hasUpper = /[A-Z]/;
  const hasSpecial = /[~!@#$%^&*()]/;
  let strength = 0;

  if(value.length > 7 && value.length < 17) {
    strength = hasLower.test(value) + hasUpper.test(value) + isNumeric.test(value) + hasSpecial.test(value);
  } else if(value.length > 0) {
    strength = 1;
  }
  return strength;
}

export function getPasswordStrength(value) {
  let passwordStrength;
  switch(determinePasswordStrength(value)) {
    case PASSWORD_NONE:
      passwordStrength = ''; // clear meter
      break;
    case PASSWORD_WEAK:
      passwordStrength = 'weak'
      break;
    case PASSWORD_FAIR:
      passwordStrength = 'fair'
      break;
    case PASSWORD_GOOD:
      passwordStrength = 'good'
      break;
    case PASSWORD_STRONG:
      passwordStrength = 'strong'
      break;
  }
  return passwordStrength;
};

